import { render, staticRenderFns } from "./PrizeList.vue?vue&type=template&id=45e8b053&scoped=true"
import script from "./PrizeList.vue?vue&type=script&lang=js"
export * from "./PrizeList.vue?vue&type=script&lang=js"
import style0 from "./PrizeList.vue?vue&type=style&index=0&id=45e8b053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8b053",
  null
  
)

export default component.exports